import React from 'react';

const Edit: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="21"
    fill="none"
    viewBox="0 0 21 21"
    width="21"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d={`M5.93555 4.83789C6.43957 4.88921 6.83284 5.31548 6.83301
      5.83301C6.83301 6.35068 6.43968 6.77679 5.93555 6.82812L5.83301
      6.83301H5C4.82331 6.83309 4.65327 6.90337 4.52832 7.02832C4.40337
      7.15327 4.33309 7.32331 4.33301 7.5V15L4.3457 15.1299C4.37121 15.258
      4.4347 15.3769 4.52832 15.4707C4.65327 15.5957 4.82331 15.6659 5
      15.666H12.5C12.6767 15.6659 12.8458 15.5957 12.9707 15.4707C13.0957
      15.3458 13.1659 15.1767 13.166 15V14.166C13.1664 13.6142 13.6142
      13.1664 14.166 13.166C14.7181 13.166 15.1657 13.614 15.166
      14.166V15C15.1659 15.7071 14.8858 16.3857 14.3857 16.8857C13.8857
      17.3858 13.2071 17.6659 12.5 17.666H5C4.29303 17.6659 3.61425 17.3856
      3.11426 16.8857C2.67696 16.4483 2.40638 15.8738 2.3457 15.2637L2.33301
      15V7.5C2.33309 6.79287 2.61424 6.11428 3.11426 5.61426C3.61428 5.11424
      4.29287 4.83309 5 4.83301H5.83301L5.93555 4.83789ZM16.0215
      1.51367C16.6511 1.57612 17.243 1.85434 17.6943 2.30566C18.2101 2.82139
      18.5 3.52066 18.5 4.25C18.5 4.97866 18.2101 5.67679 17.6953 6.19238L17.6963
      6.19336L16.6475 7.24512C16.6155 7.28993 16.5802 7.33382 16.54
      7.37402C16.5007 7.41333 16.4578 7.44714 16.4141 7.47852L10.708
      13.2061C10.5204 13.3942 10.2657 13.5 10 13.5H7.5C6.94772 13.5 6.5
      13.0523 6.5 12.5V10L6.50488 9.90137C6.52764 9.67191 6.62923 9.45623
      6.79395 9.29199L12.5176 3.58789C12.5495 3.543 12.5857 3.50024 12.626
      3.45996C12.6672 3.41876 12.7118 3.38211 12.7578 3.34961L13.8066
      2.30469C14.3223 1.78958 15.0211 1.5 15.75 1.5L16.0215 1.51367ZM8.5
      10.415V11.5H9.58496L14.4092 6.65723L13.3418 5.58984L8.5 10.415ZM15.75
      3.5C15.5511 3.5 15.3604 3.57908 15.2197 3.71973L15.2188 3.7207L14.7588
      4.17871L15.8213 5.24121L16.2793 4.78223L16.2803 4.78027L16.374
      4.66602C16.4555 4.54372 16.5 4.39915 16.5 4.25C16.5 4.0511 16.4209
      3.86037 16.2803 3.71973C16.1749 3.61436 16.0415 3.54352 15.8975
      3.51465L15.75 3.5Z`} fill="#528BFF"/>
  </svg>
);

export default Edit;

